import { useEffect } from "react"
import { hasNoAvailability } from "../read-models/fare"
import { useECommerceMachine, useNotificationMachine } from "../../../_common/machines/machines-context"
import { useSuiteCategoriesReadModel, withoutAvailability } from "../machines/suite-categories-machine"

export const useHandleNoAvailability = (origin: string) => {
    const [state] = useECommerceMachine()
    const [stateSCRM] = useSuiteCategoriesReadModel(state)
    const [, sendNF] = useNotificationMachine()
    const noFareAvailable = hasNoAvailability(state.context.fareCards)
    const noSuiteCategoryAvailable = withoutAvailability(stateSCRM)
    const noAvailability = noFareAvailable || noSuiteCategoryAvailable

    useEffect(() => {
        if (noAvailability)
            sendNF({
                type: "NOTIFY",
                kind: "noAvailability",
                info: { occupancy: state.context.guests },
                origin: origin,
            })
    }, [noAvailability, origin, sendNF, state.context.guests])
}
